/* eslint-disable react/jsx-filename-extension */

// core-js must be at the top of every webpack entry
// point for polyfills to be present in the build
import 'core-js/stable';

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';

import { initAvo } from './utils/reporting';

const element = document.getElementById('root');
const root = createRoot(element);
root.render(<StrictMode><Router><App /></Router></StrictMode>);

initAvo();

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}
